import { render, staticRenderFns } from "./detail-of-commission.vue?vue&type=template&id=2f62333a&scoped=true&"
import script from "./detail-of-commission.vue?vue&type=script&lang=js&"
export * from "./detail-of-commission.vue?vue&type=script&lang=js&"
import style0 from "./detail-of-commission.vue?vue&type=style&index=0&id=2f62333a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f62333a",
  null
  
)

export default component.exports